import { initHeader, initMobileMenu } from './header';
import { initFavourites, initRecipeFilters } from './recipes';
import { initVideoCarousel, initVideoPopup } from './video-carousel';
import { initFarmMap } from './farm-map';
import './growers';
document.addEventListener('DOMContentLoaded', () => {
    // Header & Navigation
    initHeader();
    initMobileMenu();
    // Recipe features
    initFavourites();
    initRecipeFilters();
    // Video carousel
    initVideoCarousel();
    initVideoPopup();
    // Farm map
    initFarmMap();
});
